var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState, useRef, lazy } from "react";
import { useLocation } from "react-router-dom";
import { FTLPageHeader, FTLTab, FTLTabs, FTLToolbar, } from "ftl-dashboards-ui-kit";
import { snackbarService, handleError, useDetailPage, useTabs, setProfileAction, initialProfile, useGlobalStoreState, } from "ftl-dashboards-core";
import FTLDetailPage from "../FTLDetailPage";
import { useDispatch } from "react-redux";
import { ProfileSchema } from "./model";
const PersonalDataTab = lazy(() => import("./layout/PersonalDataTab"));
const ContactDataTab = lazy(() => import("./layout/ContactDataTab"));
const SecurityTab = lazy(() => import("./layout/SecurityTab"));
export const FTLProfilePage = ({ getProfile, getCountry, getCountries, getDefaultCountry, editProfile, postPicture, deleteProfilePicture, changeProfilePassword, }) => {
    var _a;
    const location = useLocation();
    const [numberFormat, setNumberFormat] = useState(null);
    const [changePass, setChangePass] = useState(false);
    const [pictureFile, setPictureFile] = useState(null);
    const pictureSetFlag = useRef(false);
    const { profile } = useGlobalStoreState();
    const dispatch = useDispatch();
    useEffect(() => {
        if (profile !== initialProfile) {
            let data = Object.assign({}, profile);
            const countryRequest = data.countryId
                ? () => __awaiter(void 0, void 0, void 0, function* () { return (yield getCountry(data.countryId)).data.result; })
                : () => __awaiter(void 0, void 0, void 0, function* () { return (yield getDefaultCountry()).data.result; });
            countryRequest()
                .then((country) => {
                var _a, _b;
                data.countryName = country.name;
                if (country.phoneNumberFormat) {
                    setNumberFormat(country.phoneNumberFormat);
                    data.phoneNumber =
                        (_b = (_a = data.phoneNumber) === null || _a === void 0 ? void 0 : _a.replace(country.phoneNumberFormat.code + " ", "")) !== null && _b !== void 0 ? _b : "";
                }
                else {
                    data = Object.assign(Object.assign({}, data), { countryId: "", countryName: "", phoneNumber: "" });
                }
            })
                .catch((error) => {
                handleError({
                    error,
                    defaultError: "Произошла ошибка при получении данных страны",
                });
            })
                .finally(() => {
                formik.setValues(data, false);
                setEntityData(data);
                setIsFetching(false);
            });
        }
    }, [profile]);
    const { tabIndex, setTabIndex, goToNextTab, goToPrevTab } = useTabs((_a = location.state) === null || _a === void 0 ? void 0 : _a.tabIndex);
    const { formik, isFormNotChanged, setEntityData, setIsFetching, } = useDetailPage({
        pageType: "edit",
        initialValues: profile,
        enableReinitialize: true,
        validationSchema: ProfileSchema(numberFormat),
        getDetails: getProfile,
        handleFetchedEntity: (response) => {
            dispatch(setProfileAction(response.data.result));
        },
        onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
            let newValues = values;
            if (numberFormat) {
                newValues = Object.assign(Object.assign({}, values), { phoneNumber: values.phoneNumber
                        ? `${numberFormat.code} ${values.phoneNumber}`
                        : "" });
            }
            const editProfileHandler = (logoId) => __awaiter(void 0, void 0, void 0, function* () {
                yield editProfile(logoId ? Object.assign(Object.assign({}, newValues), { profileImageId: logoId }) : newValues);
                snackbarService.showSnackbar({
                    variant: "success",
                    message: "Редактирование профиля прошло успешно",
                });
                dispatch(setProfileAction(values));
            });
            try {
                if (pictureFile) {
                    const logoId = (yield postPicture(pictureFile)).data.result;
                    yield editProfileHandler(logoId);
                    setPictureFile(null);
                }
                else {
                    if (values.profileImageUrl)
                        yield deleteProfilePicture();
                    yield editProfileHandler();
                }
                setEntityData(values);
            }
            catch (error) {
                handleError({
                    error,
                    defaultError: "Произошла ошибка при редактировании профиля",
                });
            }
            finally {
                formik.setSubmitting(false);
            }
        }),
    });
    useEffect(() => {
        var _a, _b;
        if (((_a = location.state) === null || _a === void 0 ? void 0 : _a.tabIndex) && tabIndex !== ((_b = location.state) === null || _b === void 0 ? void 0 : _b.tabIndex)) {
            setTabIndex(location.state.tabIndex);
        }
    }, [location.state]);
    useEffect(() => {
        if (!formik.isSubmitting)
            if (formik.errors.firstName ||
                formik.errors.lastName ||
                formik.errors.accountStatus ||
                formik.errors.roleIds)
                setTabIndex(0);
            else if (formik.errors.countryId ||
                formik.errors.phoneNumber ||
                formik.errors.email)
                setTabIndex(1);
    }, [formik.errors, formik.isSubmitting]);
    return (React.createElement(FTLDetailPage, { formik: formik, headerComponent: React.createElement(FTLPageHeader, { title: "\u041F\u0440\u043E\u0444\u0438\u043B\u044C", BoxProps: {
                mb: 6,
            } }), toolbarComponent: React.createElement(FTLToolbar, { position: "sticky", onSaveBtnId: "form", async: formik.isSubmitting, disabled: isFormNotChanged, onSaveMessage: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", currentTabIndex: tabIndex, length: 2, goToNextTab: goToNextTab, goToPrevTab: goToPrevTab }) },
        React.createElement(FTLTabs, { value: tabIndex, onChange: (e, newValue) => {
                setTabIndex(newValue);
            } },
            React.createElement(FTLTab, { label: "\u041B\u0438\u0447\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
            React.createElement(FTLTab, { label: "\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435" }),
            React.createElement(FTLTab, { label: "\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C" })),
        React.createElement("form", { noValidate: true, id: "form", onSubmit: (e) => {
                e.preventDefault();
                formik.handleSubmit();
            } },
            tabIndex === 0 && (React.createElement(PersonalDataTab, { formik: formik, pictureSetFlag: pictureSetFlag, setPictureFile: setPictureFile })),
            tabIndex === 1 && (React.createElement(ContactDataTab, { formik: formik, numberFormat: numberFormat, setNumberFormat: setNumberFormat, getCountries: getCountries }))),
        tabIndex === 2 && (React.createElement(SecurityTab, { changePass: changePass, setChangePass: setChangePass, changeProfilePassword: changeProfilePassword, setTabIndex: setTabIndex }))));
};
export default FTLProfilePage;
//# sourceMappingURL=index.js.map